"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  AudioBookArt: ['audio-book-art', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12,23.251c-.507-1.667-3.918-3.617-9.843-3.886A1.5,1.5,0,0,1,.75,17.858V4.507A1.5,1.5,0,0,1,2.25,3', 'M12,23.251c.507-1.667,3.918-3.617,9.843-3.886a1.5,1.5,0,0,0,1.407-1.507V4.507A1.5,1.5,0,0,0,21.75,3', 'M12 15.001L12 23.251', 'M13.224,1.293A6.16,6.16,0,0,0,10.672.751c-2.985,0-5.4,2.049-5.4,4.576a4.632,4.632,0,0,0,3.3,4.213c.767.274,1.4.051,1.845-.966A1.6,1.6,0,0,1,12,7.556', 'M15.744 6.168L12.924 11.897', 'M15.14,4.326a1.383,1.383,0,0,0,.6,1.842,1.342,1.342,0,0,0,1.813-.614,2.96,2.96,0,0,0-.6-3.888C17.154,3.3,15.945,2.689,15.14,4.326Z', 'M8.643,5.159a.378.378,0,0,1,.375.381', 'M8.268,5.54a.377.377,0,0,1,.375-.381', 'M8.643,5.921a.378.378,0,0,1-.375-.381', 'M9.018,5.54a.378.378,0,0,1-.375.381', 'M10.893,2.909a.378.378,0,0,1,.375.381', 'M10.518,3.29a.377.377,0,0,1,.375-.381', 'M10.893,3.671a.378.378,0,0,1-.375-.381', 'M11.268,3.29a.378.378,0,0,1-.375.381']],
  AudioBookBlindExamA: ['audio-book-blind-exam-a', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M9.75,20.251H2.25a1.5,1.5,0,0,1-1.5-1.5V2.251a1.5,1.5,0,0,1,1.5-1.5H12.879a1.5,1.5,0,0,1,1.06.44l2.872,2.871a1.5,1.5,0,0,1,.439,1.061v7.628', 'M12.844,20.186a.558.558,0,0,1,0-.619A6.52,6.52,0,0,1,18,16.5a6.52,6.52,0,0,1,5.156,3.066.558.558,0,0,1,0,.619A6.522,6.522,0,0,1,18,23.251,6.522,6.522,0,0,1,12.844,20.186Z', 'M20.476 17.112L15.524 22.64', 'M7.5,13.5v-6a1.5,1.5,0,0,1,3,0v6', 'M7.5 10.501L10.5 10.501']],
  AudioBookExamF: ['audio-book-exam-f', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M5.25,11.251v-6a1.5,1.5,0,0,1,1.5-1.5h1.5', 'M5.25 8.251L7.5 8.251', 'M2.25,20.251a1.5,1.5,0,0,1-1.5-1.5V2.251a1.5,1.5,0,0,1,1.5-1.5H12.879a1.5,1.5,0,0,1,1.06.44l2.872,2.871a1.5,1.5,0,0,1,.439,1.061V8.251', 'M20.25,22.5V16.919a5.841,5.841,0,0,0-6-5.668,5.841,5.841,0,0,0-6,5.668V22.5', 'M10.500 19.501 A3.750 3.750 0 1 0 18.000 19.501 A3.750 3.750 0 1 0 10.500 19.501 Z', 'M8.25,22.5a3,3,0,1,1,.016-6', 'M20.25,22.5a3,3,0,1,0-.016-6']],
  AudioBookFile: ['audio-book-file', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M2.25,20.251a1.5,1.5,0,0,1-1.5-1.5V2.251a1.5,1.5,0,0,1,1.5-1.5H12.879a1.5,1.5,0,0,1,1.06.44l2.872,2.871a1.5,1.5,0,0,1,.439,1.061V8.251', 'M20.25,22.5V16.919a5.841,5.841,0,0,0-6-5.668,5.841,5.841,0,0,0-6,5.668V22.5', 'M10.500 19.501 A3.750 3.750 0 1 0 18.000 19.501 A3.750 3.750 0 1 0 10.500 19.501 Z', 'M8.25,22.5a3,3,0,1,1,.016-6', 'M20.25,22.5a3,3,0,1,0-.016-6']],
  AudioBookHeadphonesHead: ['audio-book-headphones-head', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M18,12V6.419A5.841,5.841,0,0,0,12,.751,5.841,5.841,0,0,0,6,6.419V12', 'M8.250 9.001 A3.750 3.750 0 1 0 15.750 9.001 A3.750 3.750 0 1 0 8.250 9.001 Z', 'M6,12a3,3,0,1,1,.016-6', 'M18,12a3,3,0,1,0-.016-6', 'M12,23.251c-.507-1.667-3.918-3.617-9.843-3.886A1.5,1.5,0,0,1,.75,17.858V4.507a1.5,1.5,0,0,1,1.607-1.5c.216.012.43.025.64.041', 'M12,23.251c.507-1.667,3.918-3.617,9.843-3.886a1.5,1.5,0,0,0,1.407-1.507V4.507a1.5,1.5,0,0,0-1.607-1.5q-.715.038-1.381.107', 'M12 15.751L12 23.251']],
  AudioBookRecordMicrophoneF: ['audio-book-record-microphone-f', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M11.25,20.251h-9a1.5,1.5,0,0,1-1.5-1.5V2.251a1.5,1.5,0,0,1,1.5-1.5H12.879a1.5,1.5,0,0,1,1.06.44l2.872,2.871a1.5,1.5,0,0,1,.439,1.061V7.5', 'M16.500 10.501 L21.000 10.501 L21.000 18.001 L16.500 18.001 Z', 'M23.25,16.5a4.513,4.513,0,0,1-4.5,4.5h0a4.513,4.513,0,0,1-4.5-4.5', 'M18.75 21.001L18.75 23.251', 'M7.5,13.5v-6A1.5,1.5,0,0,1,9,6h1.5', 'M7.5 10.501L9.75 10.501']],
  AudioBookVolumeMedium: ['audio-book-volume-medium', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12,22c-.507-1.667-3.918-3.618-9.843-3.887A1.5,1.5,0,0,1,.75,16.605V3.254a1.5,1.5,0,0,1,1.607-1.5,25.04,25.04,0,0,1,2.966.324', 'M12,22c.507-1.667,3.918-3.618,9.843-3.887a1.5,1.5,0,0,0,1.407-1.507V3.254a1.5,1.5,0,0,0-1.607-1.5,25.116,25.116,0,0,0-2.842.3', 'M12 15.978L12 21.999', 'M12.243,5.573a.933.933,0,0,0-.96.085L8.75,7.728H6.917a.908.908,0,0,0-.917.9v1.2a.908.908,0,0,0,.917.9H8.75l2.533,2.07a.929.929,0,0,0,.96.085.9.9,0,0,0,.507-.8v-5.7A.9.9,0,0,0,12.243,5.573Z', 'M16.5,7.3a2.594,2.594,0,0,1,0,3.587']],
  AudioBookBlindExamF: ['audio-book-blind-exam-f', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M9.75,20.251H2.25a1.5,1.5,0,0,1-1.5-1.5V2.251a1.5,1.5,0,0,1,1.5-1.5H12.879a1.5,1.5,0,0,1,1.06.44l2.872,2.871a1.5,1.5,0,0,1,.439,1.061v7.628', 'M12.844,20.186a.558.558,0,0,1,0-.619A6.52,6.52,0,0,1,18,16.5a6.52,6.52,0,0,1,5.156,3.066.558.558,0,0,1,0,.619A6.522,6.522,0,0,1,18,23.251,6.522,6.522,0,0,1,12.844,20.186Z', 'M20.476 17.112L15.524 22.64', 'M6.75,13.5v-6A1.5,1.5,0,0,1,8.25,6h1.5', 'M6.75 10.501L9 10.501']],
  AudioBookVolumeHigh: ['audio-book-volume-high', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12,22c-.507-1.667-3.918-3.618-9.843-3.887A1.5,1.5,0,0,1,.75,16.605V3.254a1.5,1.5,0,0,1,1.607-1.5,25.04,25.04,0,0,1,2.966.324', 'M12,22c.507-1.667,3.918-3.618,9.843-3.887a1.5,1.5,0,0,0,1.407-1.507V3.254a1.5,1.5,0,0,0-1.607-1.5,25.116,25.116,0,0,0-2.842.3', 'M12 15.978L12 21.999', 'M9.993,5.573a.933.933,0,0,0-.96.085L6.5,7.728H4.667a.908.908,0,0,0-.917.9v1.2a.908.908,0,0,0,.917.9H6.5L9.033,12.8a.929.929,0,0,0,.96.085.9.9,0,0,0,.507-.8v-5.7A.9.9,0,0,0,9.993,5.573Z', 'M14.25,7.3a2.594,2.594,0,0,1,0,3.587', 'M17.6,6.228a4.243,4.243,0,0,1,.013,5.728']],
  AudioBookRecordMicrophone: ['audio-book-record-microphone', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M11.25,20.251h-9a1.5,1.5,0,0,1-1.5-1.5V2.251a1.5,1.5,0,0,1,1.5-1.5H12.879a1.5,1.5,0,0,1,1.06.44l2.872,2.871a1.5,1.5,0,0,1,.439,1.061V7.5', 'M16.500 10.501 L21.000 10.501 L21.000 18.001 L16.500 18.001 Z', 'M23.25,16.5a4.513,4.513,0,0,1-4.5,4.5h0a4.513,4.513,0,0,1-4.5-4.5', 'M18.75 21.001L18.75 23.251']],
  AudioBookHeadphonesPerson: ['audio-book-headphones-person', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M18,9V6.419A5.841,5.841,0,0,0,12,.751,5.841,5.841,0,0,0,6,6.419V9', 'M8.250 7.501 A3.750 3.750 0 1 0 15.750 7.501 A3.750 3.750 0 1 0 8.250 7.501 Z', 'M12,23.251,3.222,20.262a1.281,1.281,0,0,1-.972-1.2V12.511a1.388,1.388,0,0,1,1.841-1.2L12,14.051Z', 'M20.778,20.262,12,23.251v-9.2l7.909-2.737a1.388,1.388,0,0,1,1.841,1.2v6.554A1.281,1.281,0,0,1,20.778,20.262Z', 'M15.75 15.751L18 15.001']],
  AudioBookSports: ['audio-book-sports', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12,23.11c-.507-1.667-3.918-3.617-9.843-3.886A1.5,1.5,0,0,1,.75,17.717V4.366a1.5,1.5,0,0,1,1.607-1.5,25.242,25.242,0,0,1,2.966.325', 'M12,23.11c.507-1.667,3.918-3.617,9.843-3.886a1.5,1.5,0,0,0,1.407-1.507V4.366a1.5,1.5,0,0,0-1.607-1.5,25.585,25.585,0,0,0-2.842.3', 'M12 14.11L12 23.11', 'M11.486,4.479l.267-1.76a2.131,2.131,0,0,1,3.077,0,2.132,2.132,0,0,1,0,3.078l-1.576.45', 'M14.83,5.8s1.539-.769,1.924,1.154c.261,1.306-.326,1.2-5.5,2.659', 'M11.753,2.719S12.522,1.181,10.6.8c-1.42-.284-1.335.7-2.531,5.632', 'M11.25,9.61l-.53.531a2.257,2.257,0,0,1-3.182,0h0a2.257,2.257,0,0,1,0-3.182l.53-.531Z']],
  AudioBookHeadphones: ['audio-book-headphones', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M2.25,19.5h0A1.5,1.5,0,0,1,.75,18V15a1.5,1.5,0,0,1,1.5-1.5h0A1.5,1.5,0,0,1,3.75,15v3A1.5,1.5,0,0,1,2.25,19.5Z', 'M21.75,19.5h0a1.5,1.5,0,0,1-1.5-1.5V15a1.5,1.5,0,0,1,1.5-1.5h0a1.5,1.5,0,0,1,1.5,1.5v3A1.5,1.5,0,0,1,21.75,19.5Z', 'M20.25,15v-3.75A8.274,8.274,0,0,0,12,3h0a8.275,8.275,0,0,0-8.25,8.25V15', 'M6.750 9.001 L17.250 9.001 L17.250 21.001 L6.750 21.001 Z', 'M12 12.001L14.25 12.001', 'M9.75 15.001L14.25 15.001', 'M9.75 18.001L14.25 18.001']],
  AudioBookRecordMicrophoneA: ['audio-book-record-microphone-a', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M11.25,20.251h-9a1.5,1.5,0,0,1-1.5-1.5V2.251a1.5,1.5,0,0,1,1.5-1.5H12.879a1.5,1.5,0,0,1,1.06.44l2.872,2.871a1.5,1.5,0,0,1,.439,1.061V7.5', 'M16.500 10.501 L21.000 10.501 L21.000 18.001 L16.500 18.001 Z', 'M23.25,16.5a4.513,4.513,0,0,1-4.5,4.5h0a4.513,4.513,0,0,1-4.5-4.5', 'M18.75 21.001L18.75 23.251', 'M7.5,13.5v-6a1.5,1.5,0,0,1,3,0v6', 'M7.5 10.502L10.5 10.502']],
  AudioBookMusic: ['audio-book-music', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12,23.1c-.507-1.667-3.918-3.617-9.843-3.886A1.5,1.5,0,0,1,.75,17.708V4.357a1.5,1.5,0,0,1,1.607-1.5,25.04,25.04,0,0,1,2.966.324', 'M12,23.1c.507-1.667,3.918-3.617,9.843-3.886a1.5,1.5,0,0,0,1.407-1.507V4.357a1.5,1.5,0,0,0-1.607-1.5,25.348,25.348,0,0,0-2.842.3', 'M12 14.101L12 23.101', 'M6.750 8.580 A1.500 1.500 0 1 0 9.750 8.580 A1.500 1.500 0 1 0 6.750 8.580 Z', 'M12.750 7.080 A1.500 1.500 0 1 0 15.750 7.080 A1.500 1.500 0 1 0 12.750 7.080 Z', 'M15.75,7.08V2.251A1.5,1.5,0,0,0,13.886.8l-3,.75A1.5,1.5,0,0,0,9.75,3V8.58']],
  AudioBookExamA: ['audio-book-exam-a', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M2.25,20.251a1.5,1.5,0,0,1-1.5-1.5V2.251a1.5,1.5,0,0,1,1.5-1.5H12.879a1.5,1.5,0,0,1,1.06.44l2.872,2.871a1.5,1.5,0,0,1,.439,1.061V8.251', 'M4.5,11.252v-6a1.5,1.5,0,1,1,3,0v6', 'M4.5 8.252L7.5 8.252', 'M20.25,22.5V16.919a5.841,5.841,0,0,0-6-5.668,5.841,5.841,0,0,0-6,5.668V22.5', 'M10.500 19.501 A3.750 3.750 0 1 0 18.000 19.501 A3.750 3.750 0 1 0 10.500 19.501 Z', 'M8.25,22.5a3,3,0,1,1,.016-6', 'M20.25,22.5a3,3,0,1,0-.016-6']]
};
exports["default"] = _default;